import React from "react";

import WithOverlay from "../../popups/withOverlayHoc";
import MaterialSpinner from "../../ui/materialSpinner";
import {COLORS} from "../../../colorThemes";


const NavigationLoader = (props) => {
  const {className = ""} = props;

  return (
    <WithOverlay className={"overlay--semi-dark overlay--absolute" + className}>
      {() => (
        <MaterialSpinner color={COLORS.white}/>
      )}
    </WithOverlay>
  )
};

export default NavigationLoader
